import { render } from "./BaseCarousel.vue?vue&type=template&id=82e7664c&scoped=true"
import script from "./BaseCarousel.vue?vue&type=script&lang=js"
export * from "./BaseCarousel.vue?vue&type=script&lang=js"

import "./BaseCarousel.vue?vue&type=style&index=0&id=82e7664c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e7664c"]])

export default __exports__